// Salve este arquivo como: src/components/nav/Navbar.js (Substituindo o antigo)

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HiMenu } from "react-icons/hi";
import "./Navbar.css";
import { useLanguage } from "../../context/LanguageContext";
import OffCanvasMenu from "./OffCanvasMenu"; // Importe o menu mobile

// Define sample data for case logos (replace with your actual data/paths)
const caseLogos = [
  { id: 1, src: "/assets/img/rightee2.png", alt: "Rightee", link: "/cases/rightee" },
  { id: 2, src: "/assets/img/cardiohome.png", alt: "Cardiohome", link: "/cases/cardiohome" },
  { id: 3, src: "/assets/img/grupovisco.png", alt: "Grupovisco", link: "/cases/grupovisco" }
  
  // ... outros logos
];

const Navbar = ({
  navDark,
  insurance,
  classOption,
  corporate,
  creativeAgencyOne,
  itCompany,
}) => {
  const { language, toggleLanguage, t } = useLanguage();
  const [scroll, setScroll] = useState(0);
  const [headerTop, setHeaderTop] = useState(0);
  // Estados para dropdowns
  const [servicesOpen, setServicesOpen] = useState(false);
  const [industryOpen, setIndustryOpen] = useState(false);
  const [casesOpen, setCasesOpen] = useState(false);
  // Timers para delay
  const [servicesTimeout, setServicesTimeout] = useState(null);
  const [industryTimeout, setIndustryTimeout] = useState(null);
  const [casesTimeout, setCasesTimeout] = useState(null);

  useEffect(() => {
    const stickyheader = document.querySelector(".main-header");
    if (stickyheader) {
      setHeaderTop(stickyheader.offsetTop);
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    setScroll(window.scrollY);
  };
  
  const handleLanguageChange = (lang) => {
    if (language !== lang) {
        toggleLanguage();
    }
  };

  // Funções para Services
  const handleServicesEnter = () => {
    if (servicesTimeout) clearTimeout(servicesTimeout);
    setServicesOpen(true);
  };
  const handleServicesLeave = () => {
    const timeout = setTimeout(() => setServicesOpen(false), 100);
    setServicesTimeout(timeout);
  };
  // Funções para Industry
  const handleIndustryEnter = () => {
    if (industryTimeout) clearTimeout(industryTimeout);
    setIndustryOpen(true);
  };
  const handleIndustryLeave = () => {
    const timeout = setTimeout(() => setIndustryOpen(false), 100);
    setIndustryTimeout(timeout);
  };
  // Funções para Cases
  const handleCasesEnter = () => {
    if (casesTimeout) clearTimeout(casesTimeout);
    setCasesOpen(true);
  };
  const handleCasesLeave = () => {
    const timeout = setTimeout(() => setCasesOpen(false), 100);
    setCasesTimeout(timeout);
  };

  return (
    <>
      <header
        className={`main-header z-10 ${
          creativeAgencyOne ? "creative_agency_nav " : ""
        }  ${itCompany ? "it_company_nav " : ""}     ${
          corporate ? "header-35 position-absolute top-0 start-0 zindex-9" : ""
        }   ${navDark ? "position-absolute " : ""} w-100 ${classOption} ${
          insurance && "ins-header main-header w-100 z-10 "
        }`}
      >
        <nav
          className={`navbar navbar-expand-xl z-50  ${
            corporate ? "affix" : ""
          } ${navDark ? "navbar-dark " : "navbar-light"} sticky-header ${
            scroll > headerTop ? "affix" : ""
          }`}
        >
          <div className="container d-flex align-items-center justify-content-lg-between position-relative">
            <Link to="/">
              {scroll > headerTop || !navDark || itCompany ? (
                <img
                  width={113}
                  height={36}
                  src="/assets/img/logo_infinitedev.svg"
                  alt="logo"
                  className="img-fluid logo-color"
                />
              ) : (
                <img
                  width={113}
                  height={36}
                  src="/assets/img/logo_infinitedev.svg"
                  alt="logo"
                  className="img-fluid logo-white"
                />
              )}
            </Link>

            <button
              className="navbar-toggler position-absolute right-0 border-0"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasWithBackdrop"
              aria-controls="offcanvasWithBackdrop"
            >
              <HiMenu />
            </button>

            <div className="clearfix"></div>
            <div className="collapse navbar-collapse justify-content-center">
               <ul className="nav col-12 col-md-auto justify-content-center main-menu">
                {/* Services Dropdown */}
                <li
                  className="nav-item dropdown"
                  onMouseEnter={handleServicesEnter}
                  onMouseLeave={handleServicesLeave}
                >
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    role="button"
                    aria-expanded={servicesOpen}
                  >
                    {t('navbar.services')}
                  </a>
                  <div className="dropdown-menu border-0 py-4 px-4"
                    style={{
                      width: '100vw',
                      left: 0,
                      backgroundColor: '#F1F3F5',
                      position: 'absolute',
                      top: '100%',
                      zIndex: 9999,
                      display: servicesOpen ? 'block' : 'none',
                    }}>
                    <div className="row px-12 py-2">
                      <div className="col-md-3 border-start ps-4">
                        <h6 className="drop-heading mb-3 mt-3">{t('features.featureFive.categories.ai.category')}</h6>
                        <Link to="/servico/ia-generativa" style={{ color: 'black' }} className="dropdown-link d-block mb-2"><i className="far fa-robot me-2"></i>{t('features.featureFive.categories.ai.topics.generative.title')}</Link>
                        <Link to="/servico/ia-personalizada" style={{ color: 'black' }} className="dropdown-link d-block mb-2"><i className="far fa-cogs me-2"></i>{t('features.featureFive.categories.ai.topics.custom.title')}</Link>
                      </div>
                      <div className="col-md-3"><h6 className="drop-heading mb-3 mt-3">{t('features.featureFive.categories.professionals.category')}</h6>
                        <Link to="/servico/recrutamento-tech" style={{ color: 'black' }} className="dropdown-link d-block mb-2"><i className="far fa-user-tie me-2"></i>{t('features.featureFive.categories.professionals.topics.recruitment.title')}</Link>
                        <Link to="/servico/outsourcing" style={{ color: 'black' }} className="dropdown-link d-block mb-2"><i className="far fa-handshake me-2"></i>{t('features.featureFive.categories.professionals.topics.outsourcing.title')}</Link>
                      </div>
                      <div className="col-md-3 border-start ps-4"><h6 className="drop-heading mb-3 mt-3">{t('features.featureFive.categories.software.category')}</h6>
                        <Link to="/servico/sistemas-plataformas" style={{ color: 'black' }} className="dropdown-link d-block mb-2"><i className="far fa-window-maximize me-2"></i>{t('features.featureFive.categories.software.topics.systems.title')}</Link>
                        <Link to="/servico/aplicativos" style={{ color: 'black' }} className="dropdown-link d-block mb-2"><i className="far fa-mobile-alt me-2"></i>{t('features.featureFive.categories.software.topics.apps.title')}</Link>
                      </div>
                      <div className="col-md-3 border-start ps-4"><h6 className="drop-heading mb-3 mt-3">{t('features.featureFive.categories.infrastructure.category')}</h6>
                        <Link to="/servico/migracao-cloud" style={{ color: 'black' }} className="dropdown-link d-block mb-2"><i className="far fa-cloud-upload-alt me-2"></i>{t('features.featureFive.categories.infrastructure.topics.migration.title')}</Link>
                        <Link to="/servico/gerenciar-otimizar" style={{ color: 'black' }} className="dropdown-link d-block mb-2"><i className="far fa-sliders-h me-2"></i>{t('features.featureFive.categories.infrastructure.topics.management.title')}</Link>
                      </div>
                    </div>
                  </div>
                </li>
                {/* Industry Dropdown */}
                <li
                  className="nav-item dropdown"
                  onMouseEnter={handleIndustryEnter}
                  onMouseLeave={handleIndustryLeave}
                >
                  <a className="nav-link dropdown-toggle" href="#" role="button" aria-expanded={industryOpen}>
                    {t('navbar.industry')}
                  </a>
                  <div className="dropdown-menu border-0 py-4 px-4" style={{ width: '100vw', left: 0, backgroundColor: '#F1F3F5', position: 'absolute', top: '100%', zIndex: 9999, display: industryOpen ? 'block' : 'none' }}>
                    <div className="row px-3 py-2">
                      <div className="col-2"><Link to="/industria/agronegocio" style={{ color: 'black' }} className="dropdown-link d-block mb-2"><i className="far fa-leaf me-2"></i>{t('navbar.industries.agribusiness')}</Link><Link to="/industria/bets-igaming" style={{ color: 'black' }} className="dropdown-link d-block mb-2"><i className="far fa-dice me-2"></i>{t('navbar.industries.betting')}</Link></div>
                      <div className="col-2"><Link to="/industria/educacao" style={{ color: 'black' }} className="dropdown-link d-block mb-2"><i className="far fa-graduation-cap me-2"></i>{t('navbar.industries.education')}</Link><Link to="/industria/financeiro" style={{ color: 'black' }} className="dropdown-link d-block mb-2"><i className="far fa-chart-bar me-2"></i>{t('navbar.industries.financial')}</Link></div>
                      <div className="col-2"><Link to="/industria/logistica" style={{ color: 'black' }} className="dropdown-link d-block mb-2"><i className="far fa-truck me-2"></i>{t('navbar.industries.logistics')}</Link><Link to="/industria/startups" style={{ color: 'black' }} className="dropdown-link d-block mb-2"><i className="far fa-lightbulb me-2"></i>{t('navbar.industries.startups')}</Link></div>
                      <div className="col-2"><Link to="/industria/streaming" style={{ color: 'black' }} className="dropdown-link d-block mb-2"><i className="far fa-play-circle me-2"></i>{t('navbar.industries.streaming')}</Link><Link to="/industria/tecnologia" style={{ color: 'black' }} className="dropdown-link d-block mb-2"><i className="far fa-microchip me-2"></i>{t('navbar.industries.technology')}</Link></div>
                      <div className="col-2"><Link to="/industria/varejo-e-moda" style={{ color: 'black' }} className="dropdown-link d-block mb-2"><i className="far fa-shopping-bag me-2"></i>{t('navbar.industries.retail')}</Link></div>
                    </div>
                  </div>
                </li>
                 {/* Cases Dropdown */}
                 <li
                  className="nav-item dropdown"
                  onMouseEnter={handleCasesEnter}
                  onMouseLeave={handleCasesLeave}
                >
                  <a className="nav-link dropdown-toggle" href="#" role="button" aria-expanded={casesOpen}>
                    {t('navbar.cases.cases')}
                  </a>
                  <div className="dropdown-menu border-0 py-4 px-4" style={{ width: '100vw', left: 0, backgroundColor: '#F1F3F5', position: 'absolute', top: '100%', zIndex: 9999, display: casesOpen ? 'block' : 'none' }}>
                    <h5 className="text-center mb-3 cases-dropdown-header">{t('navbar.cases.title')}</h5>
                    <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-5 g-3 justify-content-center mb-4">
                      {caseLogos.slice(0, 10).map((logo) => (
                        <div key={logo.id} className="col case-logo-item">
                          <Link to={logo.link} className="case-logo-link"><img src={logo.src} alt={logo.alt}/></Link>
                        </div>
                      ))}
                    </div>
                    <div className="text-center"><Link to="/cases" className="btn btn-primary">{t('navbar.cases.viewAll')}</Link></div>
                  </div>
                </li>
                {/* Outros links */}
                {/* <li className="nav-item"><Link to="/orcador" className="nav-link">Orçador</Link></li> */}
                <li className="nav-item"><Link to="/careers" className="nav-link">{t('navbar.carrers')}</Link></li>
              </ul>
            </div>

            <div className="action-btns text-end me-5 me-lg-0 d-none d-md-block d-lg-block">
              <div className="d-flex align-items-center">
                <Link
                  to="/request-demo"
                  className={insurance ? "ins-btn ins-primary-btn" : "btn btn-primary"}
                >
                  {t('navbar.contact')}
                </Link>
                <div className="d-flex flex-column ms-2">
                  <button
                    onClick={() => handleLanguageChange('pt')}
                    className={`btn btn-link text-decoration-none p-1 ${language === 'pt' ? 'active' : ''}`}
                    style={{ opacity: language === 'pt' ? 1 : 0.6 }}
                    aria-label="Mudar para Português"
                  >
                    <img src="/assets/img/flags/brazil.svg" alt="Português" width="24" style={{ borderRadius: '4px' }}/>
                  </button>
                  <button
                    onClick={() => handleLanguageChange('en')}
                    className={`btn btn-link text-decoration-none p-1 ${language === 'en' ? 'active' : ''}`}
                    style={{ opacity: language === 'en' ? 1 : 0.6 }}
                    aria-label="Switch to English"
                  >
                    <img src="/assets/img/flags/usa.svg" alt="English" width="24" style={{ borderRadius: '4px' }}/>
                  </button>
                </div>
              </div>
            </div>

            <div
              className="offcanvas offcanvas-end slide-from-top d-xl-none"
              tabIndex="-1"
              id="offcanvasWithBackdrop"
              aria-labelledby="offcanvasWithBackdropLabel"
            >
              <div className="offcanvas-header d-flex align-items-center mt-4">
                <Link to="/" className="d-flex align-items-center mb-md-0 text-decoration-none">
                  <img
                    width={121}
                    height={36}
                    src="/assets/img/logo_infinitedev.svg"
                    alt="logo"
                    className="img-fluid ps-2"
                  />
                </Link>
                <button
                  type="button"
                  className="btn-close text-reset"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                ></button>
              </div>
              
              <OffCanvasMenu />

            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default Navbar;